import { ICardProps } from "./Card";

export const View = (props: ICardProps) => {
  return (
    <div className={`card-container ${props.className}`}>{props.children}</div>
  );
};
